"use client";

import Link from "next/link";
import { H1 } from "~/components/common/Typography";
import { Button } from "~/components/ui/button";

import { recommendVideosAction } from "./actions";
import NewVideoForm from "./new/Form";

export default function VideosEmpty() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="w-110 flex flex-col items-center gap-3 text-center">
        <H1>
          まだ
          <ruby>
            動画<rt>どうが</rt>
          </ruby>
          が ありません
        </H1>
        <p className="text-muted-foreground">(No videos yet)</p>
        <p className="">Got a video you want to study?</p>
        <div className="relative w-full md:w-[400px] lg:w-[500px]">
          <NewVideoForm />
        </div>
        <form action={recommendVideosAction}>
          <input type="hidden" name="youtubeVideoId" value="zIIy3mlV95k" />
          Or, we can{" "}
          <Button variant="outline" className="h-auto p-2" asChild>
            <Link href="/videos">recommend</Link>
          </Button>{" "}
          some videos for you.
        </form>
      </div>
    </div>
  );
}
